import { deprecated } from "typesafe-actions";

import type { ILatestOrderDocument, ILatestQuoteDocument, IOrderHistoryDocument, IOrderHistoryQuery } from "@/shop/types/personalized/orderHistory";

const { createStandardAction } = deprecated;

export const fetchOrderHistoryDocument = createStandardAction("FETCH_HISTORY_DOCUMENT").map((query: IOrderHistoryQuery) => ({
  payload: { query }
}));

export const fetchOrderHistoryDocumentStart = createStandardAction("FETCH_HISTORY_DOCUMENT_START").map((payload: IOrderHistoryQuery) => ({ payload }));

export const fetchOrderHistoryFail = createStandardAction("FETCH_HISTORY_DOCUMENT_FAIL").map((err: Error) => ({
  payload: err,
  error: true
}));

export const fetchOrderHistoryDocumentSuccess = createStandardAction("FETCH_HISTORY_DOCUMENT_SUCCESS").map((payload: IOrderHistoryDocument) => ({
  payload
}));

export const markPartialQuickBuyForUpdate = createStandardAction("MARK_PARTIAL_QUICK_BUY_FOR_UPDATE")();

export const fetchLatestOrderHistory = createStandardAction("FETCH_HISTORY_LATEST")();

export const fetchLatestOrderHistoryStart = createStandardAction("FETCH_HISTORY_LATEST_START")();

export const fetchLatestOrderHistoryFail = createStandardAction("FETCH_HISTORY_LATEST_FAIL").map((err: Error) => ({
  payload: err,
  error: true
}));

export const fetchLatestOrderHistorySuccess = createStandardAction("FETCH_HISTORY_LATEST_SUCCESS").map(
  (payload: { orders: ILatestOrderDocument[]; quotes: ILatestQuoteDocument[]; numOrders: number; numQuotes: number }) => ({
    payload
  })
);
